const parseCourseUrl = sourceUrl => {
  const academyUrlGroup = sourceUrl && sourceUrl.match(/academy\/(\d+)\/tracks\/(\d+)\/(\d+)\/(\d+)/) || [];
  const courseIdString = academyUrlGroup[2];
  const courseId = parseInt(courseIdString, 10) || undefined;
  const lessonIdString = academyUrlGroup[3];
  const lessonId = parseInt(lessonIdString, 10) || undefined;
  const contentIdString = academyUrlGroup[4];
  const contentId = parseInt(contentIdString, 10) || undefined;
  const searchParams = sourceUrl && new URL(sourceUrl).searchParams;
  const language = searchParams && searchParams.get('language') || undefined;
  const videoTimestampString = searchParams && (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('vts'));
  const videoEndTimeString = searchParams && (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('vte'));
  const videoTimestamp = videoTimestampString && parseInt(videoTimestampString, 10) || undefined;
  const videoEndTime = videoEndTimeString && parseInt(videoEndTimeString, 10) || undefined;
  return {
    courseId,
    lessonId,
    contentId,
    videoTimestamp,
    videoTimeStart: videoTimestamp,
    videoEndTime,
    language
  };
};
const parseLessonUrl = sourceUrl => {
  const academyUrlGroup = sourceUrl && sourceUrl.match(/academy\/(\d+)\/lessons\/(\d+)\/(\d+)/) || [];
  const lessonIdString = academyUrlGroup[2];
  const lessonId = parseInt(lessonIdString, 10) || undefined;
  const contentIdString = academyUrlGroup[3];
  const contentId = parseInt(contentIdString, 10) || undefined;
  const searchParams = sourceUrl && new URL(sourceUrl).searchParams;
  const language = searchParams && searchParams.get('language') || undefined;
  const videoTimestampString = searchParams && searchParams.get('vts');
  const videoEndTimeString = searchParams && searchParams.get('vte');
  const videoTimestamp = videoTimestampString && parseInt(videoTimestampString, 10) || undefined;
  const videoEndTime = videoEndTimeString && parseInt(videoEndTimeString, 10) || undefined;
  return {
    lessonId,
    contentId,
    videoTimestamp,
    videoTimeStart: videoTimestamp,
    videoEndTime,
    language
  };
};
const parseShortUrl = sourceUrl => {
  const shortUrlGroup = sourceUrl && sourceUrl.match(/academy\/(\d+)\/shortvideo\/(\d+)/) || [];
  const shortIdString = shortUrlGroup[2];
  const shortId = parseInt(shortIdString, 10) || undefined;
  const searchParams = sourceUrl && new URL(sourceUrl).searchParams;
  const language = searchParams && searchParams.get('language') || undefined;
  const videoTimestampString = searchParams && searchParams.get('vts');
  const videoEndTimeString = searchParams && searchParams.get('vte');
  const videoTimestamp = videoTimestampString && parseInt(videoTimestampString, 10) || undefined;
  const videoEndTime = videoEndTimeString && parseInt(videoEndTimeString, 10) || undefined;
  return {
    shortId,
    videoTimestamp,
    videoStartTime: videoTimestamp,
    videoEndTime,
    language
  };
};
/**
 * Extracts the course, lesson, or short video ID, language, and video startTime based on the URL
 *
 * @param url - The URL of the Academy course, lesson, or short video Ex: https://app.hubspot.com/academy/{portalId}/lessons/1/1?language=en
 * @returns - The course, lesson, or short video ID, language, and video startTime based on the URL passed.
 */
export const extractEmbedParametersFromAcademyUrl = url => {
  if (url.includes('lessons')) {
    return parseLessonUrl(url);
  }
  if (url.includes('shortvideo')) {
    return parseShortUrl(url);
  }
  return parseCourseUrl(url);
};